import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Field } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import PropTypes from 'prop-types';
import { sortBy, cloneDeep, findIndex } from 'lodash';
import {
  Icon,
  Layout,
  RadioButton,
  RepeatableField,
  Select,
} from '@folio/stripes/components';
import css from './ServicePointsFields.css';

const omitUsedOptions = (list, usedValues, key, id) => {
  const unUsedValues = cloneDeep(list);
  if (usedValues) {
    usedValues.forEach((item, index) => {
      if (id !== index && item) {
        const usedValueIndex = findIndex(unUsedValues, v => {
          return v.label === item[key];
        });
        if (usedValueIndex !== -1) {
          unUsedValues.splice(usedValueIndex, 1);
        }
      }
    });
  }
  return unUsedValues;
};

class ServicePointsFields extends React.Component {
  static propTypes = {
    servicePoints: PropTypes.arrayOf(PropTypes.object),
    changePrimary: PropTypes.func.isRequired,
    formValues: PropTypes.object.isRequired,
    /** kware start edit */
    intl: PropTypes.object,
    /** kware end edit */
  };

  constructor(props) {
    super(props);
    this.singlePrimary = this.singlePrimary.bind(this);
    this.renderFields = this.renderFields.bind(this);
    this.radioButtonComp = this.radioButtonComp.bind(this);
    this.list = {};
  }

  singlePrimary(id) {
    const { changePrimary, formValues } = this.props;

    formValues.servicePointIds.forEach((a, i) => {
      if (i === id) {
        changePrimary(i, true);
      } else {
        changePrimary(i, false);
      }
    });
  }

  radioButtonComp({ input, ...props }) {
    return (
      <RadioButton
        onChange={() => { this.singlePrimary(props.fieldIndex); }}
        checked={input.value}
        name={input.name}
        aria-label={`servicePoint use as primary ${props.fieldIndex}`}
      />
    );
  }

  renderFields(field, index) {
    const { formValues } = this.props;

    this.list = omitUsedOptions(this.props.servicePoints, formValues.servicePointIds, 'selectSP', index);

    const sortedList = sortBy(this.list, ['label']);
    // const options = [{ label: 'Select service point', value: '' }, ...sortedList];
    /* kware start editing */
    const options = [
      {
        label: this.props.intl.formatMessage({
          id:
            'ui-tenant-settings.settings.location.locations.servicePoints.selectPlaceholder',
          defaultMessage: 'Select service point',
        }),
        value: '',
      },
      ...sortedList.map(sp => ({
        label: this.props.intl.formatMessage({
          id:
          `ui-tenant-settings.servicePoints.name.${sp.label}`,
          defaultMessage: sp.label,
        }),
        value: sp.label,
      })),
    ];
    /* kware end editing */

    return (
      <Layout className={`flex ${css.fieldsLayout}`} key={index}>
        <Layout className={`display-flex ${css.selectLayout}`}>
          <FormattedMessage id="ui-tenant-settings.settings.location.locations.servicePoints">
            {labelChunks => (
              <Field
                component={Select}
                name={`${field}.selectSP`}
                id="servicePointSelect"
                dataOptions={options}
                className={css.selectField}
                marginBottom0
                aria-label={labelChunks.join()}
              />
            )}
          </FormattedMessage>
        </Layout>
        <Layout className={`display-flex ${css.radioButtonLayout}`}>
          <Field
            component={this.radioButtonComp}
            fieldIndex={index}
            name={`${field}.primary`}
          />
        </Layout>
      </Layout>
    );
  }

  render() {
    const { formValues } = this.props;

    // make the last existing service point to be the primary one
    if (formValues.servicePointIds && formValues.servicePointIds.length === 1 && !formValues.servicePointIds[0].primary) {
      this.singlePrimary(0);
    }

    const legend = (
      <Layout className="display-flex">
        <Layout className={`${css.label} ${css.servicePointsLabel}`}>
          <FormattedMessage id="ui-tenant-settings.settings.location.locations.servicePoints" />
          <span className={css.asterisk}>*</span>
        </Layout>
        <Layout className={`${css.label} ${css.primaryLabel}`}>
          <FormattedMessage id="ui-tenant-settings.settings.location.locations.primary" />
        </Layout>
      </Layout>
    );

    return (
      <>
        <FieldArray
          // addLabel={
          //   Object.keys(this.list).length > 1 ?
          //     <Icon icon="plus-sign">Add service point</Icon> :
          //     ''
          // }
          /* kware start editing */
          addLabel={
            Object.keys(this.list).length > 1 ?
              <Icon icon="plus-sign">
                <FormattedMessage id="ui-tenant-settings.settings.location.locations.AddServicePoint" />
              </Icon> :
              ''
          }
        /* kware end editing */
          legend={legend}
          // emptyMessage={<span className={css.emptyMessage}>Location must have at least one service point</span>}
          /* kware start editing */
          emptyMessage={
            <span className={css.emptyMessage}>
              <FormattedMessage id="ui-tenant-settings.settings.location.locations.servicePoints.emptyMessage" />
            </span>}
            /* kware end editing */
          component={RepeatableField}
          name="servicePointIds"
          renderField={this.renderFields}
        />
      </>
    );
  }
}

// export default ServicePointsFields;
/** kware start edit */
export default injectIntl(ServicePointsFields);
/** kware end edit */
